import React, { useState, useEffect } from 'react';
import SetupForm from './setup_form.js';
import QuizConfirmation from './quiz_confirmation.js';
import AnimeQuiz from './anime_quiz.js';
import TitleScreen from './title_screen.js';
import  { cleanRawName, generatePastelColors } from '../util.js';
import { Anime, AnimeSong } from '../types.js';

const Slideshow = ({ setBgColor }) => {
    const [currentPage, setCurrentPage] = useState(0);

    const [username, setUsername] = useState('');

    const [animes, setAnimes] = useState([]);
    const [statusToAnimeSongs, setStatusToAnimeSongs] = useState(new Map());

    const [quizType, setQuizType] = useState("free-form");
    const [quizQuestions, setQuizQuestions] = useState([]);
    
    const pages = [
        <TitleScreen goToNextPage={() => goToPage(1)}/>,
        <SetupForm
            setUsername={setUsername} />,
        <QuizConfirmation
            animes={animes}
            statusToAnimeSongs={statusToAnimeSongs}
            quizType={quizType}
            setBgColor={setBgColor}
            setQuizType={setQuizType}
            setQuizQuestions={setQuizQuestions}
            goToNextPage={() => goToPage(3)} />,
        <AnimeQuiz 
            quizQuestions={quizQuestions}
            quizType={quizType}
            setBgColor={setBgColor} />
    ];

    async function fetchUserAnimesAndSongs(username) {
        let getAnimesRes = await fetch(`/getAnimes/${username}`);
        let userAnimes = await getAnimesRes.json();
        let userAnimeMap = new Map(userAnimes.map(animeRes => [animeRes[0], new Anime(animeRes[0], animeRes[1], animeRes[2])]));
        let getAnimeSongsRes = await Promise.all(
            userAnimes.map(animeRes =>
                fetch(`/getAnimeSongs/${animeRes[0]}`).then(res => res.json())));
        let animeSongs = [];
        let statusToAnimeSongs = new Map();
        for (let animeSongsRes of getAnimeSongsRes) {
            for (let animeSongRes of animeSongsRes) {
                let anime_id = parseInt(animeSongRes[1]);
                let anime = userAnimeMap.get(anime_id);
                let status = anime.status;
                if (!statusToAnimeSongs.has(status)) {
                    statusToAnimeSongs.set(status, []);
                }
                let animeSong = new AnimeSong(animeSongRes[0], cleanRawName(animeSongRes[0]), anime, animeSongRes[2]);
                animeSongs.push(animeSong);
                statusToAnimeSongs.get(status).push(animeSong);
            }
        }
        console.log('status to anime songs')
        console.log(statusToAnimeSongs);
        setAnimes(userAnimes);
        setStatusToAnimeSongs(statusToAnimeSongs);
    }

    useEffect(() => {
        if (username) {
            goToPage(2);
            fetchUserAnimesAndSongs(username);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [username]);

    function goToPage(pageNum) {
        if (pageNum !== 2) {
            // QuizConfirmation page needs to set its own bg color so that
            // it can sync the button color to it.
            setBgColor(generatePastelColors(1)[0]);
        }
        setCurrentPage(pageNum);
    } 
    
    return (
        <div>
            <div className="slideshow-container">
                <div className="page-content">
                    {pages[currentPage]}
                </div>
            </div>
        </div>
        
    );
};

export default Slideshow;